/**
 * @generated SignedSource<<3aec103be36ec74333d14ab8abc5a70e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type loginOauth_Query$variables = {};
export type loginOauth_Query$data = {
  readonly viewer: {
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"loginOauth_viewer">;
  } | null;
};
export type loginOauth_Query = {
  variables: loginOauth_Query$variables;
  response: loginOauth_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "login_oauth"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"login_oauth\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "loginOauth_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "loginOauth_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "loginOauth_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPersonId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a8370887c3b43a7b1c49e191b3f0712b",
    "id": null,
    "metadata": {},
    "name": "loginOauth_Query",
    "operationKind": "query",
    "text": "query loginOauth_Query {\n  viewer {\n    component(name: \"login_oauth\")\n    ...loginOauth_viewer\n    id\n  }\n}\n\nfragment loginOauth_viewer on Viewer {\n  id\n  actualPersonId\n  firstName\n  lastName\n}\n"
  }
};
})();

(node as any).hash = "677c45e58e6033e6e3dc02bce84659d7";

export default node;
